export default "__VITE_ASSET__fbc86009__"